export const IGetTransparentHeaderUseCaseType = Symbol('IGetTransparentHeaderUseCase');
